<template>
  <AiEducationLayout>
    <ContentWrap>
      <div class="flex items-center justify-between">
        <div>
          <h2 class="m-0 text-20px">基础配置</h2>
          <div class="mt-8px text-14px text-gray-500">学校、课程包与受控 AI 策略统一管理</div>
        </div>
        <el-tag type="info">基础配置</el-tag>
      </div>
    </ContentWrap>

    <ContentWrap>
      <el-tabs v-model="activeTab" @tab-change="loadActiveTab">
        <el-tab-pane label="学校管理" name="school">
          <div class="mb-12px">
            <el-button
              v-hasPermi="['ai-education:school:write']"
              type="primary"
              @click="openSchoolForm"
            >
              <Icon class="mr-5px" icon="ep:plus" />新增学校
            </el-button>
          </div>
          <el-table v-loading="loading" :data="schools">
            <el-table-column prop="name" label="学校名称" min-width="180" />
            <el-table-column prop="code" label="学校编码" width="160" />
            <el-table-column label="学段" width="100">
              <template #default="scope">
                <dict-tag :type="DICT_TYPE.AI_EDU_STAGE" :value="scope.row.eduStage" />
              </template>
            </el-table-column>
            <el-table-column prop="defaultLanguage" label="默认语言" width="120" />
            <el-table-column prop="timezone" label="时区" width="160" />
            <el-table-column label="家长视图" width="90">
              <template #default="scope">
                <el-tag :type="scope.row.parentEnabled ? 'success' : 'info'" size="small">
                  {{ scope.row.parentEnabled ? '开' : '关' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="设备" width="80">
              <template #default="scope">
                <el-tag :type="scope.row.deviceEnabled ? 'success' : 'info'" size="small">
                  {{ scope.row.deviceEnabled ? '开' : '关' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="100">
              <template #default="scope">
                <dict-tag :type="DICT_TYPE.AI_EDU_COMMON_STATUS" :value="scope.row.status" />
              </template>
            </el-table-column>
            <el-table-column label="操作" width="140">
              <template #default="scope"
                ><el-button
                  v-hasPermi="['ai-education:school:write']"
                  link
                  type="primary"
                  @click="openSchoolForm(scope.row)"
                  >编辑</el-button
                ><el-button
                  v-hasPermi="['ai-education:school:delete']"
                  link
                  type="danger"
                  @click="removeSchool(scope.row)"
                  >删除</el-button
                ></template
              >
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="组织架构" name="organization">
          <div class="mb-12px flex items-center gap-8px">
            <el-select
              v-model="organizationSchoolId"
              filterable
              placeholder="请选择学校"
              style="width: 240px"
              @change="loadOrganization"
            >
              <el-option
                v-for="item in schools"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
            <el-button v-hasPermi="['ai-education:campus:write']" @click="openCampusForm()"
              >新增校区</el-button
            >
            <el-button v-hasPermi="['ai-education:grade:write']" @click="openGradeForm()"
              >新增年级</el-button
            >
            <el-button
              v-hasPermi="['ai-education:class:write']"
              type="primary"
              @click="openClassForm()"
              >新增行政班</el-button
            >
          </div>
          <el-tabs v-model="organizationTab" type="card">
            <el-tab-pane label="行政班" name="class">
              <el-table v-loading="loading" :data="classes">
                <el-table-column prop="name" label="班级" min-width="160" />
                <el-table-column prop="code" label="编码" width="140" />
                <el-table-column label="校区" min-width="140"
                  ><template #default="s">{{
                    campusName(s.row.campusId)
                  }}</template></el-table-column
                >
                <el-table-column label="年级" min-width="120"
                  ><template #default="s">{{ gradeName(s.row.gradeId) }}</template></el-table-column
                >
                <el-table-column label="班主任" min-width="140"
                  ><template #default="s">{{
                    teacherName(s.row.headTeacherId)
                  }}</template></el-table-column
                >
                <el-table-column prop="schoolYear" label="学年" width="90" />
                <el-table-column label="操作" width="140"
                  ><template #default="s">
                    <el-button
                      v-hasPermi="['ai-education:class:write']"
                      link
                      type="primary"
                      @click="openClassForm(s.row)"
                      >编辑</el-button
                    >
                    <el-button
                      v-hasPermi="['ai-education:class:delete']"
                      link
                      type="danger"
                      @click="removeOrganization('class', s.row.id)"
                      >删除</el-button
                    >
                  </template></el-table-column
                >
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="校区" name="campus">
              <el-table :data="campuses">
                <el-table-column prop="name" label="校区" min-width="160" /><el-table-column
                  prop="code"
                  label="编码"
                  width="140"
                /><el-table-column prop="address" label="地址" min-width="220" />
                <el-table-column label="操作" width="140"
                  ><template #default="s"
                    ><el-button
                      v-hasPermi="['ai-education:campus:write']"
                      link
                      type="primary"
                      @click="openCampusForm(s.row)"
                      >编辑</el-button
                    ><el-button
                      v-hasPermi="['ai-education:campus:delete']"
                      link
                      type="danger"
                      @click="removeOrganization('campus', s.row.id)"
                      >删除</el-button
                    ></template
                  ></el-table-column
                >
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="年级" name="grade">
              <el-table :data="grades"
                ><el-table-column prop="name" label="年级" min-width="160" /><el-table-column
                  prop="stage"
                  label="学段"
                  width="140"
                /><el-table-column prop="sort" label="排序" width="90" /><el-table-column
                  label="操作"
                  width="140"
                  ><template #default="s"
                    ><el-button
                      v-hasPermi="['ai-education:grade:write']"
                      link
                      type="primary"
                      @click="openGradeForm(s.row)"
                      >编辑</el-button
                    ><el-button
                      v-hasPermi="['ai-education:grade:delete']"
                      link
                      type="danger"
                      @click="removeOrganization('grade', s.row.id)"
                      >删除</el-button
                    ></template
                  ></el-table-column
                ></el-table
              >
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>

        <el-tab-pane label="课程包" name="package">
          <div class="mb-12px">
            <el-button
              v-hasPermi="['ai-education:course-package:write']"
              type="primary"
              @click="openPackageForm"
            >
              <Icon class="mr-5px" icon="ep:plus" />新增课程包
            </el-button>
          </div>
          <el-table v-loading="loading" :data="packages">
            <el-table-column prop="name" label="课程包" min-width="180" />
            <el-table-column prop="code" label="编码" width="180" />
            <el-table-column prop="targetGrades" label="适用年级" min-width="160" />
            <el-table-column prop="languages" label="语言" min-width="150" />
            <el-table-column prop="currentVersion" label="版本" width="80" />
            <el-table-column label="状态" width="100">
              <template #default="scope"
                ><el-tag :type="[10, 20].includes(Number(scope.row.status)) ? 'success' : 'info'">{{
                  [10, 20].includes(Number(scope.row.status)) ? '已发布' : '草稿'
                }}</el-tag></template
              >
            </el-table-column>
            <el-table-column label="操作" width="300">
              <template #default="scope"
                ><el-button
                  v-if="![10, 20].includes(Number(scope.row.status))"
                  v-hasPermi="['ai-education:course-package:publish', 'ai-education:course-package:write']"
                  type="primary"
                  size="small"
                  @click="publishPackage(scope.row.id)"
                  >发布</el-button
                ><el-button
                  v-hasPermi="['ai-education:course-package:write']"
                  link
                  type="primary"
                  @click="openVersionDialog(scope.row)"
                  >版本与课程</el-button
                ><el-button
                  v-hasPermi="['ai-education:course-package:license']"
                  link
                  type="success"
                  @click="openLicenseDialog(scope.row)"
                  >学校授权</el-button
                ></template
              >
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="AI 策略" name="policy">
          <el-alert
            class="mb-12px"
            :closable="false"
            type="warning"
            title="课程问答默认要求引用；未命中学校授权知识库时必须拒答。"
          />
          <div class="mb-12px"
            ><el-button
              v-hasPermi="['ai-education:policy:write']"
              type="primary"
              @click="openPolicyForm()"
              ><Icon class="mr-5px" icon="ep:plus" />新增策略</el-button
            ></div
          >
          <el-table v-loading="loading" :data="policies">
            <el-table-column prop="name" label="策略名称" min-width="180" />
            <el-table-column label="学校" min-width="160"
              ><template #default="scope">{{
                schoolName(scope.row.schoolId)
              }}</template></el-table-column
            >
            <el-table-column label="AI 模型" min-width="160"
              ><template #default="scope">{{
                modelName(scope.row.aiModelId)
              }}</template></el-table-column
            >
            <el-table-column label="年龄范围" width="120"
              ><template #default="scope"
                >{{ scope.row.minAge }}–{{ scope.row.maxAge }}</template
              ></el-table-column
            >
            <el-table-column prop="dailyTokenLimit" label="每日 Token" width="120" />
            <el-table-column label="强制引用" width="100"
              ><template #default="scope"
                ><el-tag :type="scope.row.citationRequired ? 'success' : 'danger'">{{
                  scope.row.citationRequired ? '是' : '否'
                }}</el-tag></template
              ></el-table-column
            >
            <el-table-column label="操作" width="90"
              ><template #default="s"
                ><el-button
                  v-hasPermi="['ai-education:policy:write']"
                  link
                  type="primary"
                  @click="openPolicyForm(s.row)"
                  >编辑</el-button
                ></template
              ></el-table-column
            >
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="成员与邀请码" name="member">
          <div class="mb-12px flex gap-12px">
            <el-select
              v-model="selectedSchoolId"
              placeholder="选择学校"
              clearable
              @change="loadMemberOptions"
            >
              <el-option
                v-for="item in schools"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
            <el-select
              v-model="selectedClassId"
              placeholder="选择行政班"
              clearable
              @change="loadInvites"
            >
              <el-option
                v-for="item in classes"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
            <el-button
              v-hasPermi="['ai-education:member:import']"
              type="primary"
              @click="openImportDialog"
              >批量导入</el-button
            >
            <el-button v-hasPermi="['ai-education:member:invite']" @click="openInviteDialog"
              >创建邀请码</el-button
            >
          </div>
          <el-table v-loading="loading" :data="invites">
            <el-table-column prop="inviteCode" label="邀请码" width="150" />
            <el-table-column label="行政班" min-width="150"
              ><template #default="scope">{{
                className(scope.row.classId)
              }}</template></el-table-column
            >
            <el-table-column label="教学班" min-width="150"
              ><template #default="scope">{{
                teachingClassName(scope.row.teachingClassId)
              }}</template></el-table-column
            >
            <el-table-column label="使用次数" width="120"
              ><template #default="scope"
                >{{ scope.row.usedCount }} / {{ scope.row.maxUses }}</template
              ></el-table-column
            >
            <el-table-column prop="expireTime" label="有效期至" min-width="180" />
            <el-table-column label="状态" width="100"
              ><template #default="scope"
                ><el-tag :type="scope.row.status === 20 ? 'success' : 'info'">{{
                  scope.row.status === 20 ? '有效' : '停用'
                }}</el-tag></template
              ></el-table-column
            >
            <el-table-column label="操作" width="100"
              ><template #default="scope"
                ><el-button
                  v-if="scope.row.status === 20"
                  v-hasPermi="['ai-education:member:invite']"
                  link
                  type="danger"
                  @click="disableInvite(scope.row.id)"
                  >停用</el-button
                ></template
              ></el-table-column
            >
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </ContentWrap>

    <Dialog v-model="schoolDialog" title="新增学校" width="560px">
      <el-form ref="schoolFormRef" :model="schoolForm" :rules="schoolRules" label-width="100px">
        <el-form-item label="学校名称" prop="name"
          ><el-input v-model="schoolForm.name"
        /></el-form-item>
        <el-form-item label="学校编码" prop="code"
          ><el-input v-model="schoolForm.code"
        /></el-form-item>
        <el-form-item label="学段" prop="eduStage">
          <el-select
            v-model="schoolForm.eduStage"
            class="w-100%"
            filterable
            @change="onSchoolStageChange"
          >
            <el-option
              v-for="d in getStrDictOptions(DICT_TYPE.AI_EDU_STAGE)"
              :key="d.value"
              :label="d.label"
              :value="d.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="默认语言"
          ><el-select v-model="schoolForm.defaultLanguage"
            ><el-option label="中文" value="zh-CN" /><el-option
              label="English"
              value="en-US" /></el-select
        ></el-form-item>
        <el-form-item label="家长视图">
          <el-switch v-model="schoolForm.parentEnabled" />
        </el-form-item>
        <el-form-item label="设备管理">
          <el-switch v-model="schoolForm.deviceEnabled" />
        </el-form-item>
        <el-form-item label="联系人"><el-input v-model="schoolForm.contactName" /></el-form-item>
        <el-form-item label="联系电话"
          ><el-input v-model="schoolForm.contactMobile"
        /></el-form-item>
      </el-form>
      <template #footer
        ><el-button @click="schoolDialog = false">取消</el-button
        ><el-button :loading="saving" type="primary" @click="submitSchool"
          >保存</el-button
        ></template
      >
    </Dialog>

    <Dialog v-model="packageDialog" title="新增课程包" width="560px">
      <el-form ref="packageFormRef" :model="packageForm" :rules="packageRules" label-width="100px">
        <el-form-item label="名称" prop="name"
          ><el-input v-model="packageForm.name"
        /></el-form-item>
        <el-form-item label="编码" prop="code"
          ><el-input v-model="packageForm.code"
        /></el-form-item>
        <el-form-item label="适用年级"
          ><el-input v-model="packageForm.targetGrades" placeholder="例如：小学高年级至高中"
        /></el-form-item>
        <el-form-item label="语言"><el-input v-model="packageForm.languages" /></el-form-item>
        <el-form-item label="说明"
          ><el-input v-model="packageForm.description" type="textarea"
        /></el-form-item>
      </el-form>
      <template #footer
        ><el-button @click="packageDialog = false">取消</el-button
        ><el-button :loading="saving" type="primary" @click="submitPackage"
          >保存</el-button
        ></template
      >
    </Dialog>

    <Dialog
      v-model="versionDialog"
      :title="`${currentPackage?.name || ''} - 版本管理`"
      width="760px"
    >
      <div class="mb-12px flex gap-8px">
        <el-select
          v-model="versionCourseIds"
          multiple
          filterable
          class="flex-1"
          placeholder="选择本版本包含的课程"
        >
          <el-option
            v-for="item in trainCourses"
            :key="item.id"
            :label="item.title || item.name"
            :value="item.id"
          />
        </el-select>
        <el-button
          v-hasPermi="['ai-education:course-package:write']"
          type="primary"
          :loading="saving"
          @click="submitPackageVersion"
          >创建版本</el-button
        >
      </div>
      <el-table :data="packageVersions"
        ><el-table-column prop="versionNo" label="版本" width="90" /><el-table-column
          label="课程清单"
          min-width="240"
          show-overflow-tooltip
          ><template #default="s">{{
            packageCourseNames(s.row.courses)
          }}</template></el-table-column
        ><el-table-column label="状态" width="110"
          ><template #default="s"
            ><el-tag :type="s.row.status === 20 ? 'success' : 'info'">{{
              s.row.status === 20 ? '已发布' : '草稿'
            }}</el-tag></template
          ></el-table-column
        ><el-table-column prop="publishedTime" label="发布时间" min-width="180" /><el-table-column
          label="操作"
          width="100"
          ><template #default="s"
            ><el-button
              v-if="s.row.status === 0"
              v-hasPermi="['ai-education:course-package:publish']"
              link
              type="primary"
              @click="publishVersion(s.row.id)"
              >发布</el-button
            ></template
          ></el-table-column
        ></el-table
      >
    </Dialog>

    <Dialog
      v-model="licenseDialog"
      :title="`${currentPackage?.name || ''} - 学校授权`"
      width="700px"
    >
      <el-form :model="licenseForm" label-width="100px"
        ><el-form-item label="学校" required
          ><el-select v-model="licenseForm.schoolId" filterable class="w-100%"
            ><el-option
              v-for="item in schools"
              :key="item.id"
              :label="item.name"
              :value="item.id" /></el-select></el-form-item
        ><el-form-item label="课程包版本" required
          ><el-select v-model="licenseForm.packageVersionId" class="w-100%"
            ><el-option
              v-for="item in publishedVersions"
              :key="item.id"
              :label="`V${item.versionNo}`"
              :value="item.id" /></el-select></el-form-item
        ><el-form-item label="授权期限" required
          ><el-date-picker
            v-model="licensePeriod"
            type="datetimerange"
            value-format="YYYY-MM-DDTHH:mm:ss"
            class="w-100%" /></el-form-item
        ><el-form-item label="语言"
          ><el-select v-model="licenseForm.languages" multiple class="w-100%"
            ><el-option label="中文" value="zh-CN" /><el-option
              label="English"
              value="en-US" /></el-select></el-form-item
        ><el-form-item label="AI 配额"
          ><el-input-number
            v-model="licenseForm.aiTokenQuota"
            :min="0"
            :max="100000000" /></el-form-item
      ></el-form>
      <el-table :data="licenses" class="mb-12px"
        ><el-table-column label="学校" min-width="150"
          ><template #default="s">{{ schoolName(s.row.schoolId) }}</template></el-table-column
        ><el-table-column label="版本" width="90"
          ><template #default="s">{{
            versionName(s.row.packageVersionId)
          }}</template></el-table-column
        ><el-table-column prop="endTime" label="有效期至" min-width="170" /><el-table-column
          prop="aiTokenQuota"
          label="AI 配额"
          width="110"
        /><el-table-column label="状态" width="90"
          ><template #default="s"
            ><el-tag :type="licenseStatus(s.row).type">{{
              licenseStatus(s.row).label
            }}</el-tag></template
          ></el-table-column
        ><el-table-column label="操作" width="90"
          ><template #default="s"
            ><el-button
              v-if="s.row.status === 20"
              v-hasPermi="['ai-education:course-package:license']"
              link
              type="danger"
              @click="revokeLicense(s.row.id)"
              >撤销</el-button
            ></template
          ></el-table-column
        ></el-table
      >
      <template #footer
        ><el-button @click="licenseDialog = false">取消</el-button
        ><el-button :loading="saving" type="primary" @click="submitLicense"
          >授权</el-button
        ></template
      >
    </Dialog>

    <Dialog
      v-model="policyDialog"
      :title="policyForm.id ? '编辑 AI 策略' : '新增 AI 策略'"
      width="620px"
    >
      <el-form :model="policyForm" label-width="110px"
        ><el-form-item label="学校" required
          ><el-select v-model="policyForm.schoolId" filterable class="w-100%"
            ><el-option
              v-for="item in schools"
              :key="item.id"
              :label="item.name"
              :value="item.id" /></el-select></el-form-item
        ><el-form-item label="策略名称" required
          ><el-input v-model="policyForm.name" /></el-form-item
        ><el-form-item label="AI 模型" required
          ><el-select v-model="policyForm.aiModelId" filterable class="w-100%"
            ><el-option
              v-for="item in models"
              :key="item.id"
              :label="item.name"
              :value="item.id" /></el-select></el-form-item
        ><el-form-item label="适用年龄"
          ><el-input-number v-model="policyForm.minAge" :min="3" :max="99" /><span class="mx-8px"
            >至</span
          ><el-input-number v-model="policyForm.maxAge" :min="3" :max="99" /></el-form-item
        ><el-form-item label="每日 Token"
          ><el-input-number
            v-model="policyForm.dailyTokenLimit"
            :min="0"
            :max="10000000" /></el-form-item
        ><el-form-item label="保留天数"
          ><el-input-number v-model="policyForm.retentionDays" :min="0" :max="3650" /></el-form-item
        ><el-form-item label="敏感词"
          ><el-input
            v-model="policyForm.sensitiveWords"
            type="textarea"
            placeholder="多个词用逗号分隔" /></el-form-item
        ><el-form-item label="强制引用"
          ><el-switch v-model="policyForm.citationRequired" /></el-form-item
        ><el-form-item label="启用"><el-switch v-model="policyForm.enabled" /></el-form-item
      ></el-form>
      <template #footer
        ><el-button @click="policyDialog = false">取消</el-button
        ><el-button :loading="saving" type="primary" @click="submitPolicy"
          >保存</el-button
        ></template
      >
    </Dialog>

    <Dialog v-model="campusDialog" :title="campusForm.id ? '编辑校区' : '新增校区'" width="520px">
      <el-form :model="campusForm" label-width="90px"
        ><el-form-item label="名称" required><el-input v-model="campusForm.name" /></el-form-item
        ><el-form-item label="编码" required><el-input v-model="campusForm.code" /></el-form-item
        ><el-form-item label="地址"><el-input v-model="campusForm.address" /></el-form-item
        ><el-form-item label="状态"><el-switch v-model="campusEnabled" /></el-form-item
      ></el-form>
      <template #footer
        ><el-button @click="campusDialog = false">取消</el-button
        ><el-button :loading="saving" type="primary" @click="submitCampus"
          >保存</el-button
        ></template
      >
    </Dialog>
    <Dialog v-model="gradeDialog" :title="gradeForm.id ? '编辑年级' : '新增年级'" width="520px">
      <el-form :model="gradeForm" label-width="90px"
        ><el-form-item label="名称" required><el-input v-model="gradeForm.name" /></el-form-item
        ><el-form-item label="学段"
          ><el-select v-model="gradeForm.stage" clearable class="w-100%"
            ><el-option label="小学" value="PRIMARY" /><el-option
              label="初中"
              value="MIDDLE" /><el-option label="高中" value="HIGH" /></el-select></el-form-item
        ><el-form-item label="排序"
          ><el-input-number v-model="gradeForm.sort" :min="0" :max="999" /></el-form-item
      ></el-form>
      <template #footer
        ><el-button @click="gradeDialog = false">取消</el-button
        ><el-button :loading="saving" type="primary" @click="submitGrade">保存</el-button></template
      >
    </Dialog>
    <Dialog v-model="classDialog" :title="classForm.id ? '编辑行政班' : '新增行政班'" width="580px">
      <el-form :model="classForm" label-width="90px"
        ><el-form-item label="名称" required><el-input v-model="classForm.name" /></el-form-item
        ><el-form-item label="编码" required><el-input v-model="classForm.code" /></el-form-item
        ><el-form-item label="校区"
          ><el-select v-model="classForm.campusId" clearable class="w-100%"
            ><el-option
              v-for="item in campuses"
              :key="item.id"
              :label="item.name"
              :value="item.id" /></el-select></el-form-item
        ><el-form-item label="年级"
          ><el-select v-model="classForm.gradeId" clearable class="w-100%"
            ><el-option
              v-for="item in grades"
              :key="item.id"
              :label="item.name"
              :value="item.id" /></el-select></el-form-item
        ><el-form-item label="班主任"
          ><el-select v-model="classForm.headTeacherId" clearable filterable class="w-100%"
            ><el-option
              v-for="item in teachers"
              :key="item.id"
              :label="item.nickname || item.username"
              :value="item.id" /></el-select></el-form-item
        ><el-form-item label="学年"
          ><el-input-number v-model="classForm.schoolYear" :min="2020" :max="2100" /></el-form-item
        ><el-form-item label="状态"><el-switch v-model="classEnabled" /></el-form-item
      ></el-form>
      <template #footer
        ><el-button @click="classDialog = false">取消</el-button
        ><el-button :loading="saving" type="primary" @click="submitClass">保存</el-button></template
      >
    </Dialog>

    <Dialog v-model="importDialog" title="批量导入学生" width="760px">
      <el-alert
        class="mb-12px"
        :closable="false"
        title="每行填写一个手机号；密码为空时由会员模块按默认规则创建账号。"
      />
      <el-input
        v-model="importMobiles"
        :rows="10"
        type="textarea"
        placeholder="13800000001&#10;13800000002"
      />
      <el-select
        v-model="importTeachingClassId"
        class="mt-12px w-100%"
        clearable
        placeholder="可选：同时加入教学班"
      >
        <el-option
          v-for="item in teachingClasses"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <template #footer
        ><el-button @click="importDialog = false">取消</el-button
        ><el-button :loading="saving" type="primary" @click="submitImport"
          >开始导入</el-button
        ></template
      >
    </Dialog>

    <Dialog v-model="inviteDialog" title="创建班级邀请码" width="520px">
      <el-form label-width="100px">
        <el-form-item label="教学班">
          <el-select
            v-model="inviteForm.teachingClassId"
            class="w-100%"
            clearable
            filterable
            :placeholder="inviteSchoolIsK12 ? 'K12 建议选择（进班同步花名册）' : '可选'"
          >
            <el-option
              v-for="item in teachingClasses"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="有效期"
          ><el-date-picker
            v-model="inviteForm.expireTime"
            type="datetime"
            value-format="YYYY-MM-DDTHH:mm:ss"
        /></el-form-item>
        <el-form-item label="最大次数"
          ><el-input-number v-model="inviteForm.maxUses" :min="1" :max="10000"
        /></el-form-item>
      </el-form>
      <template #footer
        ><el-button @click="inviteDialog = false">取消</el-button
        ><el-button :loading="saving" type="primary" @click="submitInvite"
          >创建</el-button
        ></template
      >
    </Dialog>
  </AiEducationLayout>
</template>

<script setup lang="ts">
import type { FormInstance, FormRules } from 'element-plus'
import * as AiEducationApi from '@/api/aiEducation'
import request from '@/config/axios'
import { DICT_TYPE, getStrDictOptions } from '@/utils/dict'
import AiEducationLayout from './layout/AiEducationLayout.vue'

defineOptions({ name: 'AiEducation' })
const message = useMessage()
const route = useRoute()
const activeTab = ref('school')
const loading = ref(false)
const saving = ref(false)
const schools = ref<AiEducationApi.SchoolVO[]>([])
const packages = ref<AiEducationApi.CoursePackageVO[]>([])
const policies = ref<AiEducationApi.AiPolicyVO[]>([])
const models = ref<Array<{ id: number; name: string }>>([])
const classes = ref<AiEducationApi.ClassVO[]>([])
const campuses = ref<AiEducationApi.CampusVO[]>([])
const grades = ref<AiEducationApi.GradeVO[]>([])
const teachers = ref<Array<{ id: number; nickname?: string; username?: string }>>([])
const organizationSchoolId = ref<number>()
const organizationTab = ref('class')
const campusDialog = ref(false)
const gradeDialog = ref(false)
const classDialog = ref(false)
const campusEnabled = ref(true)
const classEnabled = ref(true)
const campusForm = reactive<AiEducationApi.CampusVO>({ schoolId: 0, name: '', code: '' })
const gradeForm = reactive<AiEducationApi.GradeVO>({ schoolId: 0, name: '', sort: 0 })
const classForm = reactive<Partial<AiEducationApi.ClassVO>>({})
const teachingClasses = ref<AiEducationApi.TeachingClassVO[]>([])
const invites = ref<AiEducationApi.ClassInviteVO[]>([])
const selectedSchoolId = ref<number>()
const selectedClassId = ref<number>()
const importDialog = ref(false)
const inviteDialog = ref(false)
const importMobiles = ref('')
const importTeachingClassId = ref<number>()
const inviteForm = reactive({
  teachingClassId: undefined as number | undefined,
  expireTime: '',
  maxUses: 100
})
const inviteSchoolIsK12 = computed(() => {
  const stage = schools.value.find((s) => s.id === selectedSchoolId.value)?.eduStage
  return !!stage && ['primary', 'junior', 'senior'].includes(stage)
})
const schoolDialog = ref(false)
const packageDialog = ref(false)
const policyDialog = ref(false)
const policyForm = reactive<Partial<AiEducationApi.AiPolicyVO>>({})
const versionDialog = ref(false)
const licenseDialog = ref(false)
const currentPackage = ref<AiEducationApi.CoursePackageVO>()
const packageVersions = ref<AiEducationApi.CoursePackageVersionVO[]>([])
const licenses = ref<AiEducationApi.PackageLicenseVO[]>([])
const trainCourses = ref<Array<{ id: number; name?: string; title?: string }>>([])
const versionCourseIds = ref<number[]>([])
const licensePeriod = ref<string[]>([])
const licenseForm = reactive({
  schoolId: undefined as number | undefined,
  packageVersionId: undefined as number | undefined,
  languages: ['zh-CN', 'en-US'],
  aiTokenQuota: 0
})
const publishedVersions = computed(() => packageVersions.value.filter((item) => item.status === 20))
const schoolFormRef = ref<FormInstance>()
const packageFormRef = ref<FormInstance>()
const schoolForm = reactive<AiEducationApi.SchoolVO>({
  name: '',
  code: '',
  eduStage: 'university',
  parentEnabled: false,
  deviceEnabled: false,
  defaultLanguage: 'zh-CN',
  timezone: 'Asia/Shanghai',
  status: 20
})
const packageForm = reactive<AiEducationApi.CoursePackageVO>({
  name: '',
  code: '',
  languages: 'zh-CN,en-US',
  status: 0,
  currentVersion: 1
})
const schoolRules: FormRules = {
  name: [{ required: true, message: '请输入学校名称' }],
  code: [{ required: true, message: '请输入学校编码' }]
}
const packageRules: FormRules = {
  name: [{ required: true, message: '请输入课程包名称' }],
  code: [{ required: true, message: '请输入课程包编码' }]
}

const loadActiveTab = async () => {
  loading.value = true
  try {
    if (activeTab.value === 'school') schools.value = await AiEducationApi.getSchoolList()
    if (activeTab.value === 'package') packages.value = await AiEducationApi.getCoursePackageList()
    if (activeTab.value === 'organization') {
      const [schoolList, teacherList] = await Promise.all([
        AiEducationApi.getSchoolList(),
        request.get({ url: '/system/user/simple-list' })
      ])
      schools.value = schoolList
      teachers.value = teacherList
      if (!organizationSchoolId.value && schools.value.length)
        organizationSchoolId.value = schools.value[0].id
      await loadOrganization()
    }
    if (activeTab.value === 'policy') {
      const [policyList, schoolList, modelList] = await Promise.all([
        AiEducationApi.getAiPolicyList(),
        AiEducationApi.getSchoolList(),
        request.get({ url: '/ai/model/simple-list', params: { type: 1 } })
      ])
      policies.value = policyList
      schools.value = schoolList
      models.value = modelList as Array<{ id: number; name: string }>
    }
    if (activeTab.value === 'member') {
      schools.value = await AiEducationApi.getSchoolList()
      await loadMemberOptions()
    }
  } finally {
    loading.value = false
  }
}
const openSchoolForm = (row?: AiEducationApi.SchoolVO) => {
  Object.assign(schoolForm, {
    id: row?.id,
    name: row?.name || '',
    code: row?.code || '',
    eduStage: row?.eduStage || 'university',
    parentEnabled: row?.parentEnabled ?? false,
    deviceEnabled: row?.deviceEnabled ?? false,
    defaultLanguage: row?.defaultLanguage || 'zh-CN',
    timezone: row?.timezone || 'Asia/Shanghai',
    status: row?.status ?? 20,
    contactName: row?.contactName || '',
    contactMobile: row?.contactMobile || ''
  })
  schoolDialog.value = true
}
/** K12 学段切换时默认开家长、关设备（与 PRD §5.1 / 后端 saveSchool 一致） */
const onSchoolStageChange = (stage: string) => {
  const k12 = ['primary', 'junior', 'senior'].includes(stage)
  if (k12) {
    schoolForm.parentEnabled = true
    schoolForm.deviceEnabled = false
  } else if (stage === 'university') {
    schoolForm.parentEnabled = false
    schoolForm.deviceEnabled = false
  }
}
const loadOrganization = async () => {
  if (!organizationSchoolId.value) {
    campuses.value = []
    grades.value = []
    classes.value = []
    return
  }
  ;[campuses.value, grades.value, classes.value] = await Promise.all([
    AiEducationApi.getCampusList(organizationSchoolId.value),
    AiEducationApi.getGradeList(organizationSchoolId.value),
    AiEducationApi.getClassList(organizationSchoolId.value)
  ])
}
const openCampusForm = (row?: AiEducationApi.CampusVO) => {
  if (!organizationSchoolId.value) return message.warning('请先选择学校')
  Object.assign(
    campusForm,
    row || {
      id: undefined,
      schoolId: organizationSchoolId.value,
      name: '',
      code: '',
      address: '',
      status: 20
    }
  )
  campusEnabled.value = campusForm.status !== 30
  campusDialog.value = true
}
const openGradeForm = (row?: AiEducationApi.GradeVO) => {
  if (!organizationSchoolId.value) return message.warning('请先选择学校')
  Object.assign(
    gradeForm,
    row || { id: undefined, schoolId: organizationSchoolId.value, name: '', stage: '', sort: 0 }
  )
  gradeDialog.value = true
}
const openClassForm = (row?: AiEducationApi.ClassVO) => {
  if (!organizationSchoolId.value) return message.warning('请先选择学校')
  Object.assign(
    classForm,
    row || {
      id: undefined,
      schoolId: organizationSchoolId.value,
      name: '',
      code: '',
      campusId: undefined,
      gradeId: undefined,
      headTeacherId: undefined,
      schoolYear: new Date().getFullYear(),
      status: 20
    }
  )
  classEnabled.value = classForm.status !== 30
  classDialog.value = true
}
const submitCampus = async () => {
  if (!campusForm.name.trim() || !campusForm.code.trim())
    return message.warning('请填写校区名称和编码')
  saving.value = true
  try {
    await AiEducationApi.saveCampus({
      ...campusForm,
      name: campusForm.name.trim(),
      code: campusForm.code.trim(),
      status: campusEnabled.value ? 20 : 30
    })
    campusDialog.value = false
    message.success('校区已保存')
    await loadOrganization()
  } finally {
    saving.value = false
  }
}
const submitGrade = async () => {
  if (!gradeForm.name.trim()) return message.warning('请填写年级名称')
  saving.value = true
  try {
    await AiEducationApi.saveGrade({ ...gradeForm, name: gradeForm.name.trim() })
    gradeDialog.value = false
    message.success('年级已保存')
    await loadOrganization()
  } finally {
    saving.value = false
  }
}
const submitClass = async () => {
  if (!classForm.name?.trim() || !classForm.code?.trim())
    return message.warning('请填写班级名称和编码')
  saving.value = true
  try {
    await AiEducationApi.saveClass({
      ...classForm,
      schoolId: organizationSchoolId.value,
      name: classForm.name.trim(),
      code: classForm.code.trim(),
      status: classEnabled.value ? 20 : 30
    })
    classDialog.value = false
    message.success('行政班已保存')
    await loadOrganization()
  } finally {
    saving.value = false
  }
}
const removeOrganization = async (type: 'campus' | 'grade' | 'class', id: number) => {
  await message.delConfirm()
  if (type === 'campus') await AiEducationApi.deleteCampus(id)
  if (type === 'grade') await AiEducationApi.deleteGrade(id)
  if (type === 'class') await AiEducationApi.deleteClass(id)
  message.success('删除成功')
  await loadOrganization()
}
const campusName = (id?: number) => campuses.value.find((item) => item.id === id)?.name || '-'
const gradeName = (id?: number) => grades.value.find((item) => item.id === id)?.name || '-'
const teacherName = (id?: number) =>
  teachers.value.find((item) => item.id === id)?.nickname ||
  teachers.value.find((item) => item.id === id)?.username ||
  '-'
const openPackageForm = () => {
  Object.assign(packageForm, {
    id: undefined,
    name: '',
    code: '',
    description: '',
    targetGrades: '',
    languages: 'zh-CN,en-US',
    status: 0,
    currentVersion: 1
  })
  packageDialog.value = true
}
const submitSchool = async () => {
  await schoolFormRef.value?.validate()
  saving.value = true
  try {
    await AiEducationApi.saveSchool(schoolForm)
    message.success('保存成功')
    schoolDialog.value = false
    await loadActiveTab()
  } finally {
    saving.value = false
  }
}
const submitPackage = async () => {
  await packageFormRef.value?.validate()
  saving.value = true
  try {
    const id = await AiEducationApi.saveCoursePackage(packageForm)
    message.success('保存成功')
    packageDialog.value = false
    await loadActiveTab()
    // 新建草稿后引导发布，避免概览一直显示「0 个已发布」
    if (!packageForm.id && id) {
      try {
        await message.confirm('课程包已保存为草稿，是否立即发布？')
        await AiEducationApi.publishCoursePackage(Number(id))
        message.success('发布成功')
        await loadActiveTab()
      } catch {
        /* 用户取消发布 */
      }
    }
  } finally {
    saving.value = false
  }
}
const removeSchool = async (row: AiEducationApi.SchoolVO) => {
  await message.delConfirm()
  await AiEducationApi.deleteSchool(row.id!)
  message.success('删除成功')
  await loadActiveTab()
}
const publishPackage = async (id?: number) => {
  if (!id) return
  await message.confirm('发布后本版本进入只读状态，确认发布？')
  await AiEducationApi.publishCoursePackage(id)
  message.success('发布成功')
  await loadActiveTab()
}
const openPolicyForm = (row?: AiEducationApi.AiPolicyVO) => {
  Object.assign(
    policyForm,
    row || {
      id: undefined,
      schoolId: undefined,
      name: '',
      aiModelId: undefined,
      minAge: 6,
      maxAge: 18,
      dailyTokenLimit: 20000,
      retentionDays: 180,
      sensitiveWords: '',
      citationRequired: true,
      enabled: true
    }
  )
  policyDialog.value = true
}
const submitPolicy = async () => {
  if (!policyForm.schoolId || !policyForm.aiModelId || !policyForm.name?.trim())
    return message.warning('请选择学校、AI 模型并填写策略名称')
  if ((policyForm.minAge ?? 0) > (policyForm.maxAge ?? 0))
    return message.warning('最小年龄不能大于最大年龄')
  saving.value = true
  try {
    await AiEducationApi.saveAiPolicy({
      ...(policyForm as AiEducationApi.AiPolicyVO),
      name: policyForm.name.trim()
    })
    message.success('AI 策略已保存')
    policyDialog.value = false
    await loadActiveTab()
  } finally {
    saving.value = false
  }
}
const loadPackageVersions = async () => {
  if (!currentPackage.value?.id) {
    packageVersions.value = []
    return
  }
  const versions = await AiEducationApi.getPackageVersionList(currentPackage.value.id)
  packageVersions.value = await Promise.all(
    versions.map(async (version: AiEducationApi.CoursePackageVersionVO) => {
      const detail = await AiEducationApi.getPackageVersion(version.id)
      return { ...version, courses: detail.courses || [] }
    })
  )
}
const openVersionDialog = async (row: AiEducationApi.CoursePackageVO) => {
  currentPackage.value = row
  versionCourseIds.value = []
  const [courseResult] = await Promise.all([
    request.get({ url: '/train/course/list', params: { status: 1 } }),
    loadPackageVersions()
  ])
  trainCourses.value = courseResult?.list || courseResult || []
  versionDialog.value = true
}
const submitPackageVersion = async () => {
  if (!currentPackage.value?.id || !versionCourseIds.value.length)
    return message.warning('请至少选择一门课程')
  saving.value = true
  try {
    await AiEducationApi.createPackageVersion({
      packageId: currentPackage.value.id,
      courses: versionCourseIds.value.map((trainCourseId, sort) => ({
        trainCourseId,
        sort,
        requiredFlag: true
      }))
    })
    versionCourseIds.value = []
    message.success('课程包版本已创建')
    await loadPackageVersions()
  } finally {
    saving.value = false
  }
}
const publishVersion = async (id: number) => {
  await message.confirm('发布后课程清单和知识快照将冻结，确认发布？')
  await AiEducationApi.publishPackageVersion(id)
  message.success('版本已发布')
  await loadPackageVersions()
  await loadActiveTab()
}
const openLicenseDialog = async (row: AiEducationApi.CoursePackageVO) => {
  currentPackage.value = row
  const [schoolList, versionList, licenseList] = await Promise.all([
    AiEducationApi.getSchoolList(),
    AiEducationApi.getPackageVersionList(row.id!),
    AiEducationApi.getPackageLicenseList()
  ])
  schools.value = schoolList
  packageVersions.value = await Promise.all(
    versionList.map(async (version: AiEducationApi.CoursePackageVersionVO) => {
      const detail = await AiEducationApi.getPackageVersion(version.id)
      return { ...version, courses: detail.courses || [] }
    })
  )
  licenses.value = licenseList.filter((item: AiEducationApi.PackageLicenseVO) =>
    packageVersions.value.some((version) => version.id === item.packageVersionId)
  )
  Object.assign(licenseForm, {
    schoolId: undefined,
    packageVersionId: publishedVersions.value[0]?.id,
    languages: ['zh-CN', 'en-US'],
    aiTokenQuota: 0
  })
  licensePeriod.value = []
  licenseDialog.value = true
}
const submitLicense = async () => {
  if (!licenseForm.schoolId || !licenseForm.packageVersionId || licensePeriod.value.length !== 2)
    return message.warning('请选择学校、已发布版本和完整授权期限')
  saving.value = true
  try {
    await AiEducationApi.grantPackageLicense({
      schoolId: licenseForm.schoolId,
      packageVersionId: licenseForm.packageVersionId,
      startTime: licensePeriod.value[0],
      endTime: licensePeriod.value[1],
      languages: licenseForm.languages.join(','),
      aiTokenQuota: licenseForm.aiTokenQuota,
      status: 20
    })
    message.success('学校授权成功')
    await openLicenseDialog(currentPackage.value!)
  } finally {
    saving.value = false
  }
}
const versionName = (id?: number) => {
  const version = packageVersions.value.find((item) => item.id === id)
  return version ? `V${version.versionNo}` : '-'
}
const packageCourseNames = (courses?: AiEducationApi.PackageCourseVO[]) =>
  courses
    ?.map((course) => {
      const item = trainCourses.value.find((candidate) => candidate.id === course.trainCourseId)
      return item?.title || item?.name || `课程 ${course.trainCourseId}`
    })
    .join('、') || '-'
const licenseStatus = (license: AiEducationApi.PackageLicenseVO) => {
  if (license.status !== 20) return { label: '已撤销', type: 'info' as const }
  if (new Date(license.endTime).getTime() < Date.now())
    return { label: '已到期', type: 'warning' as const }
  if (new Date(license.startTime).getTime() > Date.now())
    return { label: '待生效', type: 'primary' as const }
  return { label: '生效中', type: 'success' as const }
}
const revokeLicense = async (id: number) => {
  await message.confirm('撤销后该学校将立即失去本课程包版本的访问权限，确认撤销？')
  await AiEducationApi.revokePackageLicense(id)
  message.success('授权已撤销')
  await openLicenseDialog(currentPackage.value!)
}
const loadMemberOptions = async () => {
  selectedClassId.value = undefined
  invites.value = []
  classes.value = selectedSchoolId.value
    ? await AiEducationApi.getClassList(selectedSchoolId.value)
    : []
  teachingClasses.value = selectedSchoolId.value
    ? await AiEducationApi.getTeachingClassList({ schoolId: selectedSchoolId.value })
    : []
}
const loadInvites = async () => {
  invites.value = selectedClassId.value
    ? await AiEducationApi.getClassInviteList(selectedClassId.value)
    : []
}
const openImportDialog = () => {
  if (!selectedClassId.value) return message.warning('请先选择行政班')
  importMobiles.value = ''
  importTeachingClassId.value = undefined
  importDialog.value = true
}
const submitImport = async () => {
  const mobiles = [
    ...new Set(
      importMobiles.value
        .split(/[,，\s]+/)
        .map((item) => item.trim())
        .filter(Boolean)
    )
  ]
  if (!selectedClassId.value || !mobiles.length) return message.warning('请输入学生手机号')
  saving.value = true
  try {
    const result = await AiEducationApi.importMembers(
      mobiles.map((mobile) => ({
        classId: selectedClassId.value!,
        teachingClassId: importTeachingClassId.value,
        mobile,
        userType: 1
      }))
    )
    message.success(`导入完成：成功 ${result.successCount}，失败 ${result.failureCount}`)
    if (result.failures?.length) message.warning(result.failures.slice(0, 3).join('；'))
    importDialog.value = false
  } finally {
    saving.value = false
  }
}
const openInviteDialog = () => {
  if (!selectedSchoolId.value || !selectedClassId.value)
    return message.warning('请先选择学校和行政班')
  const defaultTc =
    teachingClasses.value.find((t) => t.classId === selectedClassId.value)?.id ||
    teachingClasses.value[0]?.id
  Object.assign(inviteForm, {
    teachingClassId: inviteSchoolIsK12.value ? defaultTc : undefined,
    expireTime: '',
    maxUses: 100
  })
  inviteDialog.value = true
}
const submitInvite = async () => {
  if (!selectedSchoolId.value || !selectedClassId.value || !inviteForm.expireTime)
    return message.warning('请填写有效期')
  if (inviteSchoolIsK12.value && !inviteForm.teachingClassId)
    return message.warning('K12 学校请选择教学班，以便学生进班后可用作业/AI')
  saving.value = true
  try {
    await AiEducationApi.createClassInvite({
      schoolId: selectedSchoolId.value,
      classId: selectedClassId.value,
      ...inviteForm
    })
    message.success('邀请码创建成功')
    inviteDialog.value = false
    await loadInvites()
  } finally {
    saving.value = false
  }
}
const disableInvite = async (id: number) => {
  await message.confirm('停用后学生将无法继续使用该邀请码，确认停用？')
  await AiEducationApi.disableClassInvite(id)
  message.success('已停用')
  await loadInvites()
}
const schoolName = (id?: number) => schools.value.find((item) => item.id === id)?.name || '-'
const modelName = (id?: number) => models.value.find((item) => item.id === id)?.name || '-'
const className = (id?: number) => classes.value.find((item) => item.id === id)?.name || '-'
const teachingClassName = (id?: number) =>
  teachingClasses.value.find((item) => item.id === id)?.name || '-'
onMounted(() => {
  const tab = String(route.query.tab || '')
  const orgTab = String(route.query.orgTab || '')
  if (tab) activeTab.value = tab
  if (orgTab) organizationTab.value = orgTab
  // K12 深链：优先选中小学演示学校
  loadActiveTab().then(() => {
    if (tab === 'organization' || tab === 'member') {
      const primary =
        schools.value.find((s) => s.eduStage === 'primary') ||
        schools.value.find((s) => ['junior', 'senior'].includes(s.eduStage || ''))
      if (primary?.id) {
        if (tab === 'organization') organizationSchoolId.value = primary.id
        if (tab === 'member') selectedSchoolId.value = primary.id
      }
    }
  })
})
</script>
